import AnnouncementBar, { AnnouncementBarProps } from 'components/gruenland/organisms/announcement-bar/AnnouncementBar';
import { TasticProps } from '../../types';

const AnnouncementBarTastic = ({ data }: TasticProps<AnnouncementBarProps>) => {
  return <AnnouncementBar text={data.text} menu={data.menu} />;
};
export default AnnouncementBarTastic;
